export const chipStyle = {
  fontWeight: 'bold',
  animation: 'pulse 2s infinite',
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 10px rgba(255, 152, 0, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(255, 152, 0, 0)',
    },
  },
}

export const colorsStyle = {
  pv: { bgcolor: '#FFE0B2', color: '#E65100' },
  hp: { bgcolor: '#C8E6C9', color: '#2E7D32' },
}
